module.exports = __webpack_public_path__ + "public/SiteImages/live-chat.svg?beeb9a70";